import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=1aca29e0&scoped=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&lang=js"
import style0 from "./LeftSideBar.vue?vue&type=style&index=0&id=1aca29e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca29e0",
  null
  
)

export default component.exports